import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { NetworkONTBlockResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const networkONTBlock = {
    record(data: typeof Requests.NetworkONTBlock.Record.Input) {
        return post<typeof data, NetworkONTBlockResponseTypes.Record>(
            `/network-ont-block/record`,
            data,
        );
    },
    create(data: typeof Requests.NetworkONTBlock.Create.Input) {
        return post<typeof data>(`/network-ont-block/create`, data);
    },
    obtain(id: string) {
        return get<NetworkONTBlockResponseTypes.Obtain>(`/network-ont-block/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/network-ont-block/delete/${id}`);
    },
    formHooks: {
        update(id: string | undefined, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.NetworkONTBlock.Update.Input) => {
                if (id === undefined) return false;
                return await asUpdateHook(
                    post<typeof data>(`/network-ont-block/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
